import { LoginType } from 'types/login-type';

export const initialState: LoginState = {
  loggedIn: undefined,
  loginType: LoginType.UsernamePassword,
  username: 'dev-user',
  permissions: '',
  loginErrorMessage: '',
  isProcessing: false
};

export interface LoginState {
  loggedIn?: boolean;
  loginType: LoginType;
  username: string;
  permissions: string;
  loginErrorMessage: string;
  isProcessing: boolean;
}


// WEBPACK FOOTER //
// ./src/pages/login/state.ts